import WorkIcon from "@mui/icons-material/Work";
import { IconButton, Tooltip } from "@mui/material";
import { useQueryClient } from "react-query";

import { useAppContextController } from "context/AppContext";

const statusColor = {
  Remove: "error",
  None: "dark",
  Submitted: "warning",
  Interview: "success",
  Declined: "error",
  Filled: "info",
  Waitlist: "violet",
  Terminated: "error",
  Completed: "primary",
};

const ApplicantJobStatusIcon = ({ status = "None", applicant, sx }) => {
  const queryClient = useQueryClient();
  const { currentJob, setCurrentJob } = useAppContextController();

  return (
    <>
      <Tooltip
        title={`${applicant?.firstName} ${applicant?.lastName} is ${
          status === "None" ? "Applied" : status
        }`}
      >
        <IconButton onClick={(e) => {}} sx={{ cursor: "default", ...sx }}>
          <WorkIcon fontSize="large" color={statusColor[status]} />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ApplicantJobStatusIcon;
